import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  Modal,
  Avatar,
  CircularProgress,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Grid,
} from '@mui/material';
import { Link } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import axios from 'axios';
import swal from 'sweetalert';
import { useHistory } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useRef } from "react";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import JSZip from "jszip";

const ConferenceSpeakerList = () => {
  const history = useHistory();
  const eventid = localStorage.getItem('eventid');
  const eventname = localStorage.getItem('eventname');
  const safeEventName = eventname.replace(/[^a-z0-9]/gi, "_");
  const [speakers, setSpeakers] = useState([]);
  const [filteredSpeakers, setFilteredSpeakers] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [selectedSpeakerStatus, setSelectedSpeakerStatus] = useState({});
  const [rejectionReasons, setRejectionReasons] = useState({});
  const [pendingStatusUpdates, setPendingStatusUpdates] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uploadFieldsVisible, setUploadFieldsVisible] = useState({});
  const [uploadInputs, setUploadInputs] = useState({});
  const [printingId, setPrintingId] = useState(null);
  const [announcement, setAnnouncement] = useState('');
  const [announcementOpen, setAnnouncementOpen] = useState(false);
  const [announcementText, setAnnouncementText] = useState('');
  const [selectedSpeakerForAnnouncement, setSelectedSpeakerForAnnouncement] = useState(null);
  const [isButtonReminderDisabled, setIsButtonReminderDisabled] = useState(false);
  const [isButoonSendWhatsappReminderDisabled, setIsButoonSendWhatsappReminderDisabled] = useState(false);
  // Search states
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermID, setSearchTermID] = useState('');
  const [filterPaymentStatus, setFilterPaymentStatus] = useState('all');

  useEffect(() => {
    axios
      .get(`/api/conference-speakers?id=${eventid}`)
      .then((response) => {
        if (response.data.status === 200) {
          const speakersData = response.data.speakers || response.data.cpindex || [];
          setSpeakers(speakersData);
          setFilteredSpeakers(speakersData);
        } else {
          setError(response.data.message || 'Failed to load speakers');
        }
      })
      .catch(() => {
        setError('Network error occurred');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [eventid]);


  const handleClickReminderEmail = (row) => {

    const id = row.id;
    const speakerStatus = row.is_active;
    //alert(`Are you sure you want to send a reminder email to ${speakerStatus}?`);
    //alert(`Function accessed with ID: ${id} and paymentStatus: ${paymentStatus}`);


    const data = {
      eventid,
      speakerStatus,

    }
    setIsButtonReminderDisabled(true);
    axios.get('/sanctum/csrf-cookie').then(response => {

      axios.post(`/api/conference-speaker-reminder-email-send/${id}`, data).then(res => {

        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success');

          // Fetch the updated data after successful submission
          axios.get(`/api/conference-speakers?id=${eventid}`)
            .then((response) => {
              if (response.data.status === 200) {
                const speakersData = response.data.speakers || response.data.cpindex || [];
                setSpeakers(speakersData);
                setFilteredSpeakers(speakersData);
              } else {
                setError(response.data.message || 'Failed to load speakers');
              }
            })
          setIsButtonReminderDisabled(false);

          //history.push('/admin/workshop/manage-particpant-order');
        }
        else {

          swal('Success', "Error", 'success');
          setIsButtonReminderDisabled(false);

        }

      });


    });
    //swal('Success', "Submit Reminder Email", 'success');
  };



  const handleClickWhatsAppReminder = (row) => {

    const id = row.id;
    const speakerStatus = row.is_active;
    // alert(`Are you sure you want to send a reminder email to ${speakerStatus}?`);

 

    const data = {
      eventid,
      speakerStatus,

    }
   setIsButoonSendWhatsappReminderDisabled(true);
    axios.get('/sanctum/csrf-cookie').then(response => {

      axios.post(`/api/conference-speaker-reminder-whatsapp-send/${id}`, data).then(res => {
        let parsedData;
        try {
          // Extract JSON at the end of the string
          const match = res.data.match(/\{.*\}$/s);
          if (match) {
            parsedData = JSON.parse(match[0]);
          } else {
            throw new Error('No JSON found');
            setIsButoonSendWhatsappReminderDisabled(false);
          }
        } catch (e) {
          console.error('Failed to parse response:', e);
          swal('Error', 'Invalid response from server', 'error');
          setIsButoonSendWhatsappReminderDisabled(false);
          return;
        }

        if (parsedData.status === 200) {
          swal('Success', parsedData.message, 'success');
          // Fetch the updated data after successful submission
          axios.get(`/api/conference-speakers?id=${eventid}`)
            .then((response) => {
              if (response.data.status === 200) {
                const speakersData = response.data.speakers || response.data.cpindex || [];
                setSpeakers(speakersData);
                setFilteredSpeakers(speakersData);
              } else {
                setError(response.data.message || 'Failed to load speakers');
              }
            })
           setIsButoonSendWhatsappReminderDisabled(false);

          //history.push('/admin/workshop/manage-particpant-order');
        }
        else {

          swal('Success', "Error", 'success');
            setIsButoonSendWhatsappReminderDisabled(false);

        }

      });


    });
    //swal('Success', "Submit Reminder Email", 'success');
  };


  // Filter speakers based on search terms and payment status
  useEffect(() => {
    let result = speakers;

    // Filter by name
    if (searchTerm) {
      result = result.filter(speaker =>
        speaker.participant_name.toLowerCase().includes(searchTerm.toLowerCase()) || speaker.participant_email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by ID
    if (searchTermID) {
      result = result.filter(speaker =>
        speaker.id.toString().includes(searchTermID)
      );
    }

    // Filter by payment status
    if (filterPaymentStatus !== 'all') {
      result = result.filter(speaker =>
        speaker.is_active.toString() === filterPaymentStatus
      );
    }


    setFilteredSpeakers(result);

  }, [searchTerm, searchTermID, filterPaymentStatus, speakers]);

  const totalRecords = speakers?.length;
  const filteredRecordsCount = filteredSpeakers?.length;

  const handleChange = (event, speakerId) => {
    const value = event.target.value;
    setSelectedSpeakerStatus((prev) => ({
      ...prev,
      [speakerId]: value,
    }));

    // Reset rejection reason if status is not rejected
    if (value !== 2) {
      setRejectionReasons((prev) => ({
        ...prev,
        [speakerId]: '',
      }));
    }

    setPendingStatusUpdates((prev) => ({
      ...prev,
      [speakerId]: true,
    }));
  };

  const handleReasonChange = (event, speakerId) => {
    const value = event.target.value;
    setRejectionReasons((prev) => ({
      ...prev,
      [speakerId]: value,
    }));
  };

  const handleStatusUpdate = async (speakerId) => {
    const newStatus = selectedSpeakerStatus[speakerId];
    const reason = rejectionReasons[speakerId] || null;

    // Validate rejection reason if status is "2" (Rejected)
    if (newStatus === 2 && (!reason || reason.trim() === '')) {
      alert('Please provide a reason for rejection');
      return;
    }

    try {
      const response = await axios.post('/api/update-speaker-status', {
        speaker_id: speakerId,
        status: newStatus,
        reason,
      });

      // Handle successful response
      if (response.data.status === 200) {
        // Mark that update is no longer pending
        setPendingStatusUpdates((prev) => ({
          ...prev,
          [speakerId]: false,
        }));

        // Update speaker list with new status
        setSpeakers((prevSpeakers) =>
          prevSpeakers.map((speaker) =>
            speaker.id === speakerId ? { ...speaker, is_active: newStatus } : speaker
          )
        );

        // Clear rejection reason if status is approved
        if (newStatus === 2) {
          setRejectionReasons((prev) => ({
            ...prev,
            [speakerId]: '',
          }));
        }


        swal('Success', 'Status updated successfully', 'success');
      } else {
        alert(response.data.message || 'Failed to update status');
        console.warn('Unexpected backend response:', response.data);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      if (error.response) {
        const { status, data } = error.response;
        console.log('Backend error response:', data);

        if (status === 422) {
          alert('Validation failed: ' + JSON.stringify(data.errors));
        } else {
          alert(data.message || 'Server error occurred');
        }
      } else if (error.request) {
        console.error('No response from backend:', error.request);
        alert('No response received from the server');
      } else {
        console.error('Request setup error:', error.message);
        alert('Error setting up request: ' + error.message);
      }
    }
  };

  const toggleUploadFields = (speakerId) => {
    setUploadFieldsVisible((prev) => ({
      ...prev,
      [speakerId]: !prev[speakerId],
    }));
  };

  const handleInputChange = (e, speakerId) => {
    const { name, value, files } = e.target;
    setUploadInputs((prev) => ({
      ...prev,
      [speakerId]: {
        ...prev[speakerId],
        [name]: files ? files[0] : value,
      },
    }));
  };

  const handleUploadSubmit = async (speakerId) => {
    const { title, file } = uploadInputs[speakerId] || {};
    if (!title || !file) {
      alert("Please provide both title and file");
      return;
    }

    const formData = new FormData();
    formData.append("speaker_id", speakerId);
    formData.append("title", title);
    formData.append("uploaded_file", file);

    try {
      const res = await axios.post("/api/upload-speaker-document", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status === 200) {
        swal('Success', "Document uploaded successfully", 'success');
        setSpeakers((prev) =>
          prev.map((sp) =>
            sp.id === speakerId
              ? {
                ...sp,
                documents: [...(sp.documents || []), res.data.document],
              }
              : sp
          )
        );

        // Reset input
        setUploadInputs((prev) => ({
          ...prev,
          [speakerId]: { title: "", file: null },
        }));
        setUploadFieldsVisible((prev) => ({
          ...prev,
          [speakerId]: false,
        }));
      } else {
        alert(res.data.message || "Upload failed");
      }
    } catch (error) {
      console.error(error);
      alert("Upload error");
    }
  };

  const fetchFiles = async () => {
    try {
      const res = await axios.get('/api/org-get-speaker-announcement', {
        params: { eventid: localStorage.getItem('eventid') }
      });

      if (res.data.status === 200) {
        // setAnnouncement(res.data.message); // store the object
        //  / console.log('Announcement fetched successfully:', res.data.message);
        setAnnouncementText(res.data.message?.conference_announcement || ''); // set the text field value
      }
    } catch (err) {
      console.error('Failed to fetch announcement', err);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);



  const handleAnnouncementSend = async () => {
    if (!announcementText.trim()) {
      alert('Please enter an announcement message');
      return;
    }
    console.log("message: announcementText,", announcementText, eventid);

    try {
      const response = await axios.post('/api/org-upload-speaker-announcement', {
        message: announcementText,
        eventid,
        // speaker_id: selectedSpeakerForAnnouncement ? selectedSpeakerForAnnouncement.id : null,
      });
      if (response.data.status === 200) {
        swal('Success', 'Announcement sent successfully', 'success');
        fetchFiles();
        //setAnnouncementText('');
        setAnnouncementOpen(false);
      } else {
        alert(response.data.message || 'Failed to send announcement');
      }
    } catch (error) {
      console.error('Error sending announcement:', error);
      if (error.response) {
        const { status, data } = error.response;
        console.log('Backend error response:', data);
        if (status === 422) {
          alert('Validation failed: ' + JSON.stringify(data.errors));
        } else {
          alert(data.message || 'Server error occurred');
        }
      } else if (error.request) {
        console.error('No response from backend:', error.request);
        alert('No response received from the server');
      } else {
        console.error('Request setup error:', error.message);
        alert('Error setting up request: ' + error.message);
      }
    }
  };



  const handleFilterPaymentStatusChange = (event) => {
    setFilterPaymentStatus(event.target.value);
  };

  function myFun(id) {
    axios.post('/api/conference-particpant-badge-print', { id: id })
      .then(res => {
        if (res.data.status === 200) {
          // Success - no action needed
        } else {
          alert('Error: Message Not Sent');
        }
      })
      .catch(error => {
        console.error("API Error:", error.response || error.message || error);
        alert('Error: An error occurred');
      });
  }



  const handleBarcodeClick = (row) => {
    setPrintingId(row.id);
    const id = row.id;
    const name = row.participant_name;
    const nameTitle = row.name_title;

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('Popup blocked. Please allow popups for this website.');
      return;
    }

    printWindow.myFun = myFun;

    printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Print</title>
            <style>
                body {
                    text-align: center;
                    margin: 0;
                    padding: 20px;
                }
                #content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: left;
                    padding-top: 190px;
                }
                #printButton {
                    display: block;
                    position: fixed;
                    top: 0;
                    right: 0;
                    margin: 20px;
                    padding: 10px;
                    background-color: green;
                    color: white;
                    border: none;
                    cursor: pointer;
                }
                @media print {
                    #printButton {
                        display: none;
                    }
                    @page {
                        size: auto;
                        margin: 0;
                    }
                }
            </style>
            <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
            <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
        </head>
        <body>
            <button id="printButton" onclick="window.print(); myFun(${id});">Print</button>
            <div id="content">
                <div id="qrcode" style="margin-bottom: 0.5em;"></div>
                <h3 style="text-align: center; line-height: 1.5; margin: 0;">ID: ${id}</h3>
                <h3 style="text-align: center; line-height: 1; margin: 0;">Name: ${nameTitle} ${name}</h3>
                <div id="barcode-container">
                    <svg id="barcode"></svg>
                </div>
            </div>
            <script>
                document.addEventListener('DOMContentLoaded', () => {
                    // Generate QR Code
                    const qrcodeSvg = document.getElementById("qrcode");
                    new QRCode(qrcodeSvg, {
                        text: '${id}',
                        width: 128,
                        height: 128,
                    });

                    // // Generate Barcode
                    // const barcodeSvg = document.getElementById("barcode");
                    // JsBarcode(barcodeSvg, '${id}', {
                    //     format: "CODE128",
                    //     displayValue: true,
                    //     fontSize: 14,
                    //     textMargin: 10,
                    // });

                    // // Adjust barcode dimensions
                    // barcodeSvg.setAttribute('width', '128');
                    // barcodeSvg.setAttribute('height', '80');
                    // barcodeSvg.setAttribute('preserveAspectRatio', 'none');
                    
                });
            </script>
        </body>
        </html>
    `);

    printWindow.document.close();
  };


  //   const handleExportToExcel = () => {
  //   if (!filteredSpeakers || filteredSpeakers.length === 0) {
  //     alert("No speaker data available");
  //     return;
  //   }

  //   const exportData = filteredSpeakers.map((speaker, index) => ({
  //     "S.No": index + 1,
  //     Name: speaker.participant_name,
  //     Email: speaker.participant_email,
  //     Country: speaker.participant_country || "Saudi Arabia",
  //     Status: speaker.is_active === 1 ? "Approved" : speaker.is_active === 0 ? "Pending" : "Rejected",
  //     Documents: speaker.documents?.map(doc => doc.uploaded_file_url).join(", ") || "No documents",
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(exportData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Speakers");

  //   XLSX.writeFile(wb, "Speakers.xlsx");
  // };
  const handleExportToExcel = () => {
    if (!filteredSpeakers || filteredSpeakers.length === 0) {
      alert("No speaker data available");
      return;
    }

    const exportData = filteredSpeakers.map((speaker, index) => ({
      "S.No": index + 1,
      Name: speaker.participant_name,
      Email: speaker.participant_email,
      Country: speaker.participant_country || "Saudi Arabia",
      Status: speaker.is_active === 1 ? "Approved" : speaker.is_active === 0 ? "Pending" : "Rejected",
      Documents: speaker.documents?.map(doc => doc.uploaded_file_url).join(", ") || "No documents",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Speakers");

    XLSX.writeFile(wb, `${safeEventName}_Speakers.xlsx`);
  };








  const staticChange = eventid == 68;

  const modalRef = React.useRef();

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    let yOffset = 10;

    // 🟢 Basic details
    doc.text(
      `Full Name: ${selectedSpeaker?.name_title || ""} ${selectedSpeaker?.participant_name || "N/A"}`,
      10,
      yOffset
    );
    yOffset += 10;

    doc.text(`Email: ${selectedSpeaker?.participant_email || "N/A"}`, 10, yOffset);
    yOffset += 10;

    doc.text(`Phone: ${selectedSpeaker?.participant_phone_number || "N/A"}`, 10, yOffset);
    yOffset += 10;

    doc.text(`Position: ${selectedSpeaker?.participant_profession || "N/A"}`, 10, yOffset);
    yOffset += 10;

    doc.text(`Gender: ${selectedSpeaker?.participant_gender == 1 ? "Male" : "Female"}`, 10, yOffset);
    yOffset += 10;

    // 🟢 Organization / Hospital
    doc.text(
      `${staticChange ? "Hospital Name" : "Organization"}: ${staticChange
        ? selectedSpeaker?.participant_hostpital_organization || "N/A"
        : selectedSpeaker?.participant_company || "N/A"
      }`,
      10,
      yOffset
    );
    yOffset += 20;

    // 🟢 Biography / Applicant Details
    doc.text(
      `${staticChange ? "Applicant Details" : "Biography"}: ${selectedSpeaker?.speaker_details?.biography || "N/A"
      }`,
      10,
      yOffset
    );
    yOffset += 20;

    // 🟢 Country / City / Sector / Nationality
    doc.text(
      `Country: ${staticChange ? "Saudi Arabia" : selectedSpeaker?.speaker_details?.participant_country || "N/A"}`,
      10,
      yOffset
    );
    yOffset += 10;

    doc.text(
      `City: ${staticChange
        ? selectedSpeaker?.participant_city || "N/A"
        : selectedSpeaker?.speaker_details?.participant_city || "N/A"
      }`,
      10,
      yOffset
    );
    yOffset += 10;

    doc.text(
      `${staticChange ? "Sector" : "Nationality"}: ${selectedSpeaker?.speaker_details?.nationality || "N/A"
      }`,
      10,
      yOffset
    );
    yOffset += 10;
    doc.text(
      `${staticChange ? "Service" : "Company"}: ${selectedSpeaker?.participant_company || "N/A"
      }`,
      10,
      yOffset
    );
    yOffset += 20;

    // 🟢 Passport details
    if (selectedSpeaker?.speaker_details?.passport_number) {
      doc.text(
        `${staticChange ? "Bed Capacity (Total/ICU/NICU)" : "Passport Number"}: ${selectedSpeaker.speaker_details.passport_number
        }`,
        10,
        yOffset
      );
      yOffset += 10;

      if (!staticChange && selectedSpeaker?.speaker_details?.passport_expiry) {
        doc.text(`Passport Expiry: ${selectedSpeaker.speaker_details.passport_expiry}`, 10, yOffset);
        yOffset += 20;
      }
    }

    // 🟢 Accommodation / Invitation / National Programs
    if (staticChange) {
      doc.text(
        "Is your antimicrobial stewardship program involved in national programs? " +
        `${selectedSpeaker?.speaker_details?.needs_accommodation ? "Yes" : "No"}`,
        10,
        yOffset
      );
      yOffset += 20;
    } else {
      doc.text(
        `Accommodation Needed: ${selectedSpeaker?.speaker_details?.needs_accommodation ? "Yes" : "No"}`,
        10,
        yOffset
      );
      yOffset += 10;

      doc.text(
        `Invitation Letter Needed: ${selectedSpeaker?.speaker_details?.needs_invitation_letter ? "Yes" : "No"}`,
        10,
        yOffset
      );
      yOffset += 20;
    }

    // 🟢 Documents
    if (selectedSpeaker?.documents?.length > 0) {
      doc.text("Uploaded Documents:", 10, yOffset);
      yOffset += 10;

      selectedSpeaker.documents.forEach((docItem, index) => {
        doc.text(`${index + 1}. ${docItem.title} (${docItem.uploaded_file.split(".").pop()})`, 15, yOffset);
        yOffset += 10;
      });
    } else {
      doc.text("No documents uploaded.", 10, yOffset);
    }

    // 🔑 Save and trigger download
    doc.save(`${selectedSpeaker?.participant_name || "speaker"}-details.pdf`);
  };




  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 40, ml: 60 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ mt: 14 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f9fafc',
        py: 4,
        marginTop: '100px',
        marginLeft: '3%',
        width: '80%',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Conference Speakers
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap', // allows wrapping on smaller screens
          justifyContent: 'flex-end',
          gap: 2,
          mb: 3
        }}
      >


        {/* Record counts */}
        <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
          <span>Total Records: {totalRecords}</span>
          <span style={{ margin: '0 10px' }}>|</span>
          <span>Filtered Records: {filteredRecordsCount}</span>
        </Box>

        {/* Search and filter */}
        <TextField
          label="Filter By Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ minWidth: 200 }}
        />

        <TextField
          label="Filter By ID"
          value={searchTermID}
          onChange={(e) => setSearchTermID(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ minWidth: 150 }}
        />

        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={filterPaymentStatus}
            onChange={handleFilterPaymentStatusChange}
            label="Status"
          >
            <MenuItem value="all">All Statuses</MenuItem>
            <MenuItem value="1">Approved</MenuItem>
            <MenuItem value="0">Pending</MenuItem>
            <MenuItem value="2">Rejected</MenuItem>
          </Select>
        </FormControl>

        {/* Action buttons */}
        <Button
          color="primary"
          size="small"
          variant="contained"
          component={Link}
          to={`/admin/conference/upload-speaker-file`}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Upload File For Speakers
        </Button>

        <Button
          variant="contained"
          color="info"
          size="small"
          onClick={() => {

            setAnnouncementOpen(true);
          }}
          sx={{ mt: 1 }}
        >
          Send Announcement
        </Button>

        <Button
          color="success"
          size="small"
          variant="contained"
          onClick={() => history.goBack()}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Back
        </Button>

      </Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2, justifyContent: 'flex-end' }}>
        <Button variant="contained" color="success" onClick={handleExportToExcel}>
          Download All Speakers (Excel)
        </Button>

      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Registered ID</TableCell>
              <TableCell>Photo</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>Upload File For Speaker</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSpeakers.length > 0 ? (
              filteredSpeakers.map((speaker) => (
                <TableRow key={speaker.id}>
                  <TableCell>{speaker.id}</TableCell>
                  <TableCell>
                    <Avatar src={speaker?.photo_path || '/default-avatar.jpg'} alt={speaker.participant_name} />
                  </TableCell>
                  <TableCell>{speaker.participant_name}</TableCell>
                  <TableCell>{speaker.participant_email}</TableCell>
                  <TableCell>{speaker.participant_country || "Saudi Arabia"}</TableCell>
                  <TableCell>
                    <Box sx={{ mt: 2 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => toggleUploadFields(speaker.id)}
                      >
                        Upload Document
                      </Button>

                      {uploadFieldsVisible[speaker.id] && (
                        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <TextField
                            label="Document Title"
                            name="title"
                            size="small"
                            value={uploadInputs[speaker.id]?.title || ""}
                            onChange={(e) => handleInputChange(e, speaker.id)}
                          />
                          <input
                            type="file"
                            name="file"
                            accept="image/*,application/pdf"
                            onChange={(e) => handleInputChange(e, speaker.id)}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleUploadSubmit(speaker.id)}
                          >
                            Upload
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setSelectedSpeaker(speaker);
                            setOpenModal(true);
                          }}
                        >
                          View Details
                        </Button>

                        {speaker.is_active === 1 ? (
                          <Button variant="contained" color="success">
                            Approved
                          </Button>
                        ) : speaker.is_active === 0 ? (
                          <Button variant="contained" color="error">
                            Pending
                          </Button>
                        ) : (
                          <Button variant="contained" color="warning">
                            Rejected
                          </Button>
                        )}
                        

                            <Button
                              sx={{
                                ":hover": { color: "white" },
                                position: 'relative',
                                '& .MuiButton-endIcon': {
                                  borderLeft: '1px solid white',
                                  padding: '0 6px',
                                  marginLeft: '20px',
                                },
                                marginTop: 1,
                                marginBottom: 1,
                              }}
                              endIcon={<span>{speaker.whatsapp_count || 0}</span>}
                              color="success"
                              size='small'
                              variant='contained'
                              onClick={() => handleClickWhatsAppReminder(speaker, speaker.is_active)}
                            disabled={isButoonSendWhatsappReminderDisabled}
                            >
                              Send Wahtsapp Reminder
                            </Button>
                         


                      </Box>

                      <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <InputLabel id={`invitation-letter-label-${speaker.id}`}>Change Status</InputLabel>
                        <Select
                          labelId={`invitation-letter-label-${speaker.id}`}
                          name="needs_invitation_letter"
                          value={selectedSpeakerStatus[speaker.id] ?? speaker.is_active}
                          onChange={(e) => handleChange(e, speaker.id)}
                          label="Change Status"
                        >
                          <MenuItem value={1}>Approved</MenuItem>
                          <MenuItem value={0}>Pending</MenuItem>
                          <MenuItem value={2}>Rejected</MenuItem>
                        </Select>
                      </FormControl>

                      {selectedSpeakerStatus[speaker.id] === 2 && (
                        <TextField
                          multiline
                          minRows={3}
                          label="Rejection Reason"
                          value={rejectionReasons[speaker.id] || ''}
                          onChange={(e) => handleReasonChange(e, speaker.id)}
                          fullWidth
                          sx={{ mt: 1 }}
                          required
                        />
                      )}

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={
                            !pendingStatusUpdates[speaker.id] ||
                            (selectedSpeakerStatus[speaker.id] === 2 &&
                              (!rejectionReasons[speaker.id] || rejectionReasons[speaker.id].trim() === ''))
                          }
                          onClick={() => handleStatusUpdate(speaker.id)}
                        >
                          Update Status
                        </Button>
                        {
                          speaker?.is_active === 1 && (
                            <Button
                              sx={{
                                ":hover": { color: "white" },
                                marginTop: 1,
                                marginBottom: 1,
                              }}
                              color='primary'
                              size='small'
                              variant='contained'
                              onClick={() => handleBarcodeClick(speaker)}
                            >
                              Print
                            </Button>
                          )
                        }
                        <Button
                          sx={{
                            marginBottom: 1,
                            marginTop: 1,
                            ":hover": { color: "white" },
                            // backgroundColor: backGroundButtonByEvent,
                            position: 'relative',
                            '& .MuiButton-endIcon': {
                              borderLeft: '1px solid white',
                              padding: '0 6px',
                              marginLeft: '20px',
                            }
                          }}
                          color='primary'
                          size='small'
                          variant='contained'
                          endIcon={<span>{speaker.reminder_count || 0}</span>}

                          onClick={() => handleClickReminderEmail(speaker, speaker.is_active)}
                          disabled={isButtonReminderDisabled}
                        >
                          Reminder Email
                        </Button>


                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No speakers found matching your criteria
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Speaker Details Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="speaker-details-modal">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          {selectedSpeaker && (
            <>
              <Typography variant="h5" gutterBottom>
                {selectedSpeaker.participant_name}
              </Typography>

              <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
                <Avatar src={selectedSpeaker?.photo_path || '/default-avatar.jpg'} alt={selectedSpeaker.participant_name} />
                <Box>
                  <Typography>
                    <strong>Full Name:</strong> {selectedSpeaker.name_title}: {selectedSpeaker.participant_name}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {selectedSpeaker.participant_email}
                  </Typography>
                  <Typography>
                    <strong>Phone:</strong> {selectedSpeaker.participant_phone_number || 'Not provided'}
                  </Typography>
                  <Typography>
                    <strong>Position:</strong> {selectedSpeaker.participant_profession || 'Not provided'}
                  </Typography>
                  <Typography>

                    <Typography>
                      <strong>Gender:</strong> {selectedSpeaker?.participant_gender == 1 ? "Male" : "Female"}
                    </Typography>


                    <strong>{staticChange ? "Hospital Name" : "Organization"} :</strong>  {staticChange ? selectedSpeaker.participant_hostpital_organization : selectedSpeaker.participant_company}
                  </Typography>
                </Box>
              </Box>

              <Typography paragraph>
                <strong>{staticChange ? "Applicant Deatils" : "Biography"}:</strong> {selectedSpeaker?.speaker_details?.biography || 'Not provided'}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                <Box>
                  <Typography>
                    <strong>Country:</strong> {staticChange ? "Saudi Arabia" : selectedSpeaker?.speaker_details?.participant_country}
                  </Typography>
                  <Typography>
                    <strong>City:</strong>  {staticChange ? selectedSpeaker.participant_city : selectedSpeaker?.speaker_details?.participant_city}
                  </Typography>
                  <Typography>
                    <strong>{staticChange ? "Sector" : "Nationality"}:</strong> {selectedSpeaker?.speaker_details?.nationality || 'Not provided'}
                  </Typography>
                  <Typography sx={{ display: staticChange ? "block" : "none" }}>
                    <strong>Service:</strong> {selectedSpeaker?.participant_company || 'Not provided'}
                  </Typography>
                </Box>

                {selectedSpeaker?.speaker_details?.passport_number && (
                  <Box>
                    <Typography>
                      <strong>{staticChange ? "Bed Capacity (Total/ICU/NICU)" : "Passport Number"}:</strong> {selectedSpeaker?.speaker_details.passport_number}
                    </Typography>
                    <Typography sx={{ display: staticChange ? "none" : "block" }}>
                      <strong>Passport Expiry:</strong> {selectedSpeaker?.speaker_details.passport_expiry}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ display: 'flex', gap: 1 }}>
                  {selectedSpeaker?.speaker_details?.linkedin && (
                    <Button href={selectedSpeaker?.speaker_details.linkedin} target="_blank" startIcon={<LinkedInIcon />} size="small">
                      LinkedIn
                    </Button>
                  )}
                  {selectedSpeaker?.speaker_details?.twitter && (
                    <Button href={selectedSpeaker?.speaker_details.twitter} target="_blank" startIcon={<TwitterIcon />} size="small">
                      Twitter
                    </Button>
                  )}
                  {selectedSpeaker?.speaker_details?.youtube && (
                    <Button href={selectedSpeaker?.speaker_details.youtube} target="_blank" startIcon={<YouTubeIcon />} size="small">
                      YouTube
                    </Button>
                  )}
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Typography>
                    <strong>{staticChange ? "Is your antimicrobial stewardship program activity involved in national programs and initiatives (i.e. submitting KPI's, participate in awareness campaigns, reporting to PHA)?" : "Accommodation Needed"}:</strong> <br></br> {selectedSpeaker?.speaker_details?.needs_accommodation ? 'Yes' : 'No'}
                  </Typography>
                  <Typography sx={{ display: staticChange ? "none" : "block" }}>
                    <strong>Invitation Letter Needed:</strong> {selectedSpeaker?.speaker_details?.needs_invitation_letter ? 'Yes' : 'No'}
                  </Typography>

                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Uploaded Documents
                    </Typography>

                    {selectedSpeaker?.documents?.length > 0 ? (
                      selectedSpeaker.documents.map((doc) => {
                        const fileExtension = doc.uploaded_file.split('.').pop().toLowerCase();
                        const isImage = /(jpg|jpeg|png|gif)$/i.test(fileExtension);
                        const isPdf = /pdf$/i.test(fileExtension);
                        const isExcel = /(xlsx|xls)$/i.test(fileExtension);

                        return (
                          <Box key={doc.id} sx={{ mb: 2 }}>
                            <Typography>
                              <strong>Document Title:</strong> {doc.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              File type: {fileExtension.toUpperCase()}
                            </Typography>

                            {isImage ? (
                              <Box
                                component="img"
                                src={doc.uploaded_file_url}
                                alt={doc.title}
                                sx={{ maxWidth: '200px', maxHeight: '200px', mt: 1, borderRadius: 1, boxShadow: 1 }}
                              />
                            ) : isPdf ? (
                              <Typography sx={{ mt: 1 }}>
                                <Button
                                  variant="outlined"
                                  href={doc.uploaded_file_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View PDF
                                </Button>
                              </Typography>
                            ) : (
                              <Typography sx={{ mt: 1 }}>
                                <Button
                                  variant="contained"
                                  href={doc.uploaded_file_url}
                                  download
                                  rel="noopener noreferrer"
                                >
                                  Download {isExcel ? 'Excel' : 'File'}
                                </Button>
                              </Typography>
                            )}
                          </Box>
                        );
                      })
                    ) : (
                      <Typography>No documents uploaded.</Typography>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, mt: 4 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownloadPDF}
                      >
                        Download the {selectedSpeaker.name_title}: {selectedSpeaker.participant_name} Record  in PDF
                      </Button>
                    </Box>
                  </Box>
                  {/* 
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Uploaded Documents
                    </Typography>

                    {selectedSpeaker?.documents?.length > 0 ? (
                      selectedSpeaker.documents.map((doc) => {
                        const isImage = /\.(jpg|jpeg|png|gif)$/i.test(doc.uploaded_file);
                        return (
                          <Box key={doc.id} sx={{ mb: 2 }}>
                            <Typography>
                              <strong>Document Title:</strong> {doc.title}
                            </Typography>

                            {isImage ? (
                              <Box
                                component="img"
                                src={doc.uploaded_file_url}
                                alt={doc.title}
                                sx={{ maxWidth: '200px', maxHeight: '200px', mt: 1, borderRadius: 1, boxShadow: 1 }}
                              />
                            ) : (
                              <Typography>
                                <a href={doc.uploaded_file_url} target="_blank" rel="noopener noreferrer">
                                  View / Download File
                                </a>
                              </Typography>
                            )}
                          </Box>
                        );
                      })
                    ) : (
                      <Typography>No documents uploaded.</Typography>
                    )}
                  </Box> */}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Modal>



      {/* Announcement Modal */}
      <Modal
        open={announcementOpen}
        onClose={() => setAnnouncementOpen(false)}
        aria-labelledby="announcement-modal-title"
        aria-describedby="announcement-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="announcement-modal-title" variant="h6" component="h2">
            Send Announcement
          </Typography>
          <TextField
            id="announcement-text"
            label="Announcement Text"
            multiline
            rows={4}
            value={announcementText || ''}
            onChange={(e) => setAnnouncementText(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // Handle announcement sending logic here
              handleAnnouncementSend();

            }}
            sx={{ mt: 2 }}
          >
            Send Announcement
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ConferenceSpeakerList;